import { useTranslate } from '@tolgee/react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { GetStaticProps } from 'next';
import { TournamentCategoryItemFragment } from '@amf/shared/types/graphql';
import { sdk } from '@amf/shared/lib/graphQlClient';
import { getPartners, NavigationProps } from '@amf/shared/utils/navigation';
import { getLanguageLocale } from '@amf/shared/utils/languages';
import Container from '@amf/shared/components/layout/Container';

import Layout from 'components/layout/Layout';
import TournamentCreate from 'components/tournament/TournamentCreate';
import Meta from 'components/Meta';

interface TournamentCreatePageProps extends NavigationProps {
  categories: TournamentCategoryItemFragment[];
}

export default function TournamentCreatePage({
  navigation,
  partners,
  categories,
}: TournamentCreatePageProps) {
  const { t } = useTranslate('malyfotbal');
  return (
    <GoogleReCaptchaProvider reCaptchaKey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}>
      <div className='TournamentCreatePage'>
        <Layout navigation={navigation} partners={partners}>
          <Meta title={t('tournaments.create.title')} />
          <Container position='center'>
            <h1>{t('tournaments.create.title')}</h1>
            <TournamentCreate categories={categories} />
          </Container>
        </Layout>
      </div>
    </GoogleReCaptchaProvider>
  );
}

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const { categories, navigation } = await sdk.NewTournamentPage({
    union: process.env.NEXT_PUBLIC_UNION,
    locale: getLanguageLocale(locale!),
  });

  return {
    props: {
      categories,
      navigation,
      partners: await getPartners(),
    },
    revalidate: 10,
  };
};
